// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:21Svja */\n.L9QO_{display:flex;flex-direction:column;gap:var(--audio-spacing-48);margin:0 auto;max-width:48rem;padding:var(--audio-spacing-24) var(--audio-spacing-16) 0;width:100%}@media (min-width:1280px){.L9QO_{padding-left:0;padding-right:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": "L9QO_"
};
export default ___CSS_LOADER_EXPORT___;
